import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';
import {
  format,
  getBundleProductDetails,
  getIsAntiWaste,
} from '@monofront/business/utils';
import { useProductPricing } from '@monofront/business/hooks/product/useProductPricing';

interface IProductPrice {
  product: IProduct;
  UNSAFE_className?: string;
  children?: React.ReactNode;
  quantity?: number;
}

const ProductPrice: React.FC<IProductPrice> = ({
  product,
  UNSAFE_className = '',
  children,
  quantity = 1,
}) => {
  const tCatalog = useTranslations('Catalog');

  if (!product) {
    return null;
  }

  const isAntiWaste = getIsAntiWaste(product.tags);
  const isComparisonPriceHidden = product.meta.finance?.hide_comparison_price;
  const productPricing = useProductPricing(product, quantity);

  const { productBundleNumber, productBundleSale } = getBundleProductDetails(
    product.tags,
  );

  const isKit = Boolean(productBundleSale && product.combination_product_data);
  const isBundle = Boolean(!isKit && productBundleNumber && productBundleSale);

  return (
    <p
      className={`product-price tw-inline-block tw-self-center ${UNSAFE_className}`}
    >
      {!isComparisonPriceHidden && Boolean(productPricing.compareAtPrice) && (
        <span className="product-price-striked tw-flex tw-items-center">
          <s className="tw-lf-discounted-price-md">
            <span className="tw-sr-only">{tCatalog('oldPrice')}</span>
            {format(productPricing.compareAtPrice)}
          </s>
          {children}
        </span>
      )}
      <span
        className={`tw-lf-title-md tw-mr-2 tw-mt-0.5 ${
          isAntiWaste || isKit || isBundle ? 'tw-text-red-600' : ''
        }`}
      >
        {format(productPricing.price)}
      </span>
      {!isComparisonPriceHidden && productPricing.discountPercent && (
        <span className="tw-lf-discount tw-lf-discount-md">
          {`-${productPricing.discountPercent}%`}
        </span>
      )}
    </p>
  );
};

export default ProductPrice;
